import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import classes from './Publish.module.scss';
import classNames from 'classnames';
import { Categories } from './Categories';
import { Snippets } from './Snippets';
import { PostingPlan } from './PostingPlan';
import { MediaLibrary } from './MediaLibrary';
import { PostScheduleWrapper } from './PostSchedule/PostScheduleWrapper';
import { PostLibraryWrapper } from './PostSchedule/PostLibraryWrapper';
import { InstagramGridWrapper } from './InstagramGrid/InstagramGridWrapper';
import { NotFoundRedirect } from '../App/NotFoundRedirect';
import { ScrollProvider } from '../../providers/ScrollProvider';

export const PublishView = (): JSX.Element => {
  const globalClasses = classNames(classes.Publish);

  return (
    <ScrollProvider className={globalClasses}>
      <div className={'grid-x'}>
        <Routes>
          <Route path={'queue'} element={<PostScheduleWrapper />} />
          <Route path={'library'} element={<PostLibraryWrapper />} />
          <Route path={'categories'} element={<Categories isArchivedView={false} />} />
          <Route path={'categories/archived'} element={<Categories isArchivedView />} />
          <Route path={'plan'} element={<PostingPlan />} />
          <Route path={'snippets'} element={<Snippets context={'PAGE'} />} />
          <Route path={'instagram'} element={<InstagramGridWrapper />} />
          <Route path={'media'} element={<MediaLibrary />} />
          <Route path={'/'} element={<Navigate to={'queue'} replace />} />
          <Route path={'*'} element={<NotFoundRedirect to={'queue'} />} />
        </Routes>
      </div>
    </ScrollProvider>
  );
};
